var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempDownloadWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 450,
    viewBox: "0 0 802 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 746,
    height: 394,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.811 166.882H415.429V143.647C415.429 141.091 413.339 139 410.786 139H392.214C389.661 139 387.571 141.091 387.571 143.647V166.882H380.189C376.057 166.882 373.968 171.901 376.893 174.829L398.204 196.159C400.014 197.971 402.939 197.971 404.75 196.159L426.061 174.829C428.986 171.901 426.943 166.882 422.811 166.882ZM369 213.353C369 215.909 371.089 218 373.643 218H429.357C431.911 218 434 215.909 434 213.353C434 210.797 431.911 208.706 429.357 208.706H373.643C371.089 208.706 369 210.797 369 213.353Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 266,
    width: 53.494,
    height: 53.4574,
    rx: 7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.192 307.242C354.498 307.239 353.832 306.965 353.337 306.479L341.118 294.268C340.626 293.776 340.35 293.11 340.35 292.415C340.35 291.719 340.626 291.053 341.118 290.561C341.61 290.07 342.277 289.793 342.973 289.793C343.668 289.793 344.335 290.07 344.827 290.561L355.192 300.919L377.776 278.35C378.019 278.107 378.308 277.914 378.627 277.782C378.945 277.65 379.286 277.583 379.63 277.583C379.975 277.583 380.316 277.65 380.634 277.782C380.952 277.914 381.241 278.107 381.485 278.35C381.729 278.594 381.922 278.883 382.054 279.201C382.185 279.519 382.253 279.859 382.253 280.204C382.253 280.548 382.185 280.889 382.054 281.207C381.922 281.525 381.729 281.814 381.485 282.057L357.047 306.479C356.551 306.965 355.886 307.239 355.192 307.242Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 266,
    width: 53.494,
    height: 53.4574,
    rx: 7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.922 308.108C459.273 308.462 459.47 308.941 459.47 309.44C459.47 309.939 459.273 310.418 458.922 310.772C458.564 311.118 458.086 311.311 457.588 311.311C457.091 311.311 456.613 311.118 456.255 310.772L440.747 295.252L425.239 310.772C424.882 311.118 424.404 311.311 423.906 311.311C423.409 311.311 422.931 311.118 422.573 310.772C422.222 310.418 422.024 309.939 422.024 309.44C422.024 308.941 422.222 308.462 422.573 308.108L438.104 292.61L422.573 277.113C422.275 276.75 422.122 276.288 422.145 275.819C422.168 275.35 422.365 274.905 422.698 274.573C423.03 274.241 423.475 274.044 423.945 274.021C424.414 273.998 424.876 274.15 425.239 274.448L440.747 289.969L456.255 274.448C456.619 274.15 457.08 273.998 457.55 274.021C458.02 274.044 458.464 274.241 458.797 274.573C459.129 274.905 459.326 275.35 459.35 275.819C459.373 276.288 459.22 276.75 458.922 277.113L443.39 292.61L458.922 308.108Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2732",
    x: 0,
    y: 0,
    width: 802,
    height: 450,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_118_2732"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2732",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempDownloadWeb);
export default __webpack_public_path__ + "static/media/TempDownloadWeb.02551990ad68048960fb2a6886a1c565.svg";
export { ForwardRef as ReactComponent };